// Module
var code = "<react-component name=\"EmailSendingDomainsReport\"></react-component>\n";
// Exports
module.exports = code;